
import HttpService from "./htttp.service";

class DownloadService {
  // Method to download the profile to the backend
  async downloadProfile(platform, profileData) {
    try {
      const payload = {
        data: {
          type: "profile",
          attributes: profileData,
        },
      };
      const response = await HttpService.post(`/platform/${platform.toLowerCase()}/download`, payload);
      return response.data;
    } catch (error) {
      console.error("Error downloading profile:", error);
      throw error;
    }
  }  
}

export default new DownloadService();
